var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShipmentSearch = function SvgShipmentSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.927.5v3.327M11.333 5.563V3.827H.521v6.654a.83.83 0 0 0 .831.832h4.012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.52 3.827 1.248-2.404A1.66 1.66 0 0 1 3.215.5h5.423a1.66 1.66 0 0 1 1.489.923l1.206 2.404M9.896 12.411a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M13.396 13.411l-1.73-1.73"
  }))));
};
export default SvgShipmentSearch;